import Client from 'config/axios';
import posthog from 'posthog-js';
import { SuggestedPostData } from './createSuggestedPost';

export const updateSuggestedPost = async (
  token: string,
  id: string,
  suggestedPost: SuggestedPostData,
  twitterURL: any,
  linkedinURL: any,
  instagramURL: any,
  tiktokURL: any,
  whatsappURL: any,
  type: any,
  photo?: string
) => {
  const objectSocialNetworks = async (
    content: string,
    typeUpload: string,
    urlFile: any
  ) => {
    let objectSN;
    switch (typeUpload) {
      case 'image':
        objectSN = {
          content: content,
          type: typeUpload,
          picturesUrls: urlFile,
          hashtags: false,
          bitly: []
        };
        break;
      case 'video':
        objectSN = {
          content: content,
          type: typeUpload,
          videoUrl: urlFile
        };
        break;
      case 'pdf':
        objectSN = {
          content: content,
          type: typeUpload,
          pdfUrl: urlFile
        };
        break;
      default:
        objectSN = {
          content: content,
          type: typeUpload
        };
    }
    return objectSN;
  };

  const body = {
    name: suggestedPost.name,
    description: suggestedPost.description,
    photo: photo,
    includesFacebook: suggestedPost.includesFacebook,
    includesTwitter: suggestedPost.includesTwitter,
    includesLinkedin: suggestedPost.includesLinkedin,
    includesInstagram: suggestedPost.includesInstagram,
    includesTiktok: suggestedPost.includesTiktok,
    includesWhatsapp: suggestedPost.includesWhatsapp,
    companyId: suggestedPost.companyId,
    ambassadorId: suggestedPost.ambassadorId,
    status: suggestedPost.status,
    contentPerSocialNetwork: {
      facebook: {
        content: '',
        link: suggestedPost.linkFacebook,
        type: 'share'
      },
      twitter: await objectSocialNetworks(
        suggestedPost.contentTwitter,
        twitterURL && twitterURL?.url?.length > 0 ? twitterURL?.type : 'text',
        twitterURL?.url
      ),
      linkedin: await objectSocialNetworks(
        suggestedPost.contentLinkedin,
        linkedinURL && linkedinURL.url?.length > 0 ? linkedinURL?.type : 'text',
        linkedinURL?.url
      ),
      instagram: await objectSocialNetworks(
        suggestedPost.contentInstagram,
        instagramURL?.type,
        instagramURL?.url
      ),
      tiktok: await objectSocialNetworks(
        suggestedPost.contentTiktok,
        tiktokURL?.type,
        tiktokURL?.url
      ),
      whatsapp: await objectSocialNetworks(
        suggestedPost.contentWhatsapp,
        whatsappURL?.type,
        whatsappURL?.url
      )
    }
  };
  console.log(`POST Endpoint: suggested_post/update/${id}`);
  console.log('POST Body:', body);
  try {
    const { data } = await Client.post(`suggested_post/update/${id}`, body, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    posthog.capture('Actualización de Propuesta de Campaña', {
      UpdateSuggestedPost: data
    });
    return { data: data };
  } catch (response) {
    const result = response as any;
    return { errors: result?.response?.data };
  }
};
